import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { isPlatformBrowser, isPlatformServer, PlatformLocation } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
  selector: 'contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUs implements OnInit {

  formContact: FormGroup;
  private subscription: Subscription;
  private sending: boolean;
  public completed: boolean;
  private error: boolean;
  private isServer: boolean;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(APP_SETTINGS) private settings: Object,
    private http: HttpClient
  ) { 

    this.isServer = isPlatformServer(this.platformId);
  }

  ngOnInit() {
    if (!this.isServer){
      window.scrollTo(0, 0);
    }

    this.formContact = this.formBuilder.group({
      first_name: ['',],
      last_name: ['',],
      email_address: ['', Validators.email],
      message: ['', Validators.required]
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onSubmit() {
    this.sending = true;
    const formValue = this.formContact.value;
    const url = this.settings['DATA_API_ENDPOINT'] + '/contact-us';
    //const url = 'http://7bcbfca9.ngrok.io/v1/contact-us';
    let formData: FormData = new FormData();
    for (let key of Object.keys(formValue)) {
      formData.append(key, formValue[key]);
    }
    this.subscription = this.http
      .post(url, formData)
      .subscribe((data) => {
        if (data["status"] !== "sent") {
          this.error = true;
        }
        else {
          this.completed = true;
          this.error = false
        }
        this.sending = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/contact-us/contact-us.component.ts